import { Col, Form, Row, Table } from "antd";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { MitigationSectionViewProps } from ".";
import { AMOUNT_UTIL } from "../../../../../../utils/amount.utils";
import { DATE_UTIL } from "../../../../../../utils/dateUtils";


const ControlEffectiveness = (props: MitigationSectionViewProps) => {

    const { t } = useTranslation();

    const columns = useRef([
        {
            title: t("ScenarioMitigation.lbControlName"),
            dataIndex: 'control_name',
            key: 'control_name',
            render: (text: string) => <span className='blue-text'>{text}</span>
        },
        {
            title: t("ScenarioMitigation.lbWeight"),
            dataIndex: 'weight',
            key: 'weight',
            render: (text: number) => AMOUNT_UTIL.convertNumericToFormattedString(text)
        },
        {
            title: t("ScenarioMitigation.lbOverallValue"),
            dataIndex: 'overall_value',
            key: 'overall_value',
            render: (text: number) => AMOUNT_UTIL.convertNumericToFormattedString(text)
        }
    ]);


    return (
        <div className="section-wrapper">
            <div className="table-wrapper">
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Table
                            dataSource={props.data?.control_effectivenesses}
                            columns={columns.current} rowKey="id"
                            pagination={false} />
                    </Col>
                    <Col span={24} className="text-total">
                        <p>{t("ScenarioMitigation.lbTotalEffectivenessValue")}</p><span className="primary-text">{AMOUNT_UTIL.convertNumericToFormattedString(props.data?.total_effectiveness_value)}</span>
                    </Col>
                    <Col span={24} className="text-total">
                        <p>{t("ScenarioMitigation.lbControlEffectiveness")}</p><span className="primary-text"> {props.data?.control_effectiveness_type?.name}
                        </span>
                    </Col>
                </Row>
            </div>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ScenarioMitigation.lbMandatoryMeetingRequired")}
                    >
                        <span>
                            {props.data?.mandatory_meeting_required ? t("ScenarioMitigation.lbYes") : t("ScenarioMitigation.lbNo")}
                        </span>
                    </Form.Item>
                </Col>
            </Row>


            <Form.Item
                label={
                    t("ScenarioMitigation.lbReviewDate")}
            >
                {
                    props.data?.review_dates && props.data?.review_dates.map((item, index) => (
                        <span key={index}>
                            {DATE_UTIL.convertServerToViewFormat(item.review_date)}
                        </span>
                    ))
                }
            </Form.Item>


            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ScenarioMitigation.lbAdditionalNotes")}
                    >
                        <span>
                            {props.data?.additional_notes}
                        </span>
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default ControlEffectiveness;